module.exports = __webpack_public_path__ + "media/images/front/programs/03-0b24c6daa3d634c37c60bb50475c320c.jpg";